import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ModeProvider = React.createContext();

export default function ModeContextProvider({ children }) {
    const { i18n } = useTranslation();
    const [mode, setMode] = useState(null);
    const [lang, setLang] = useState(null);

    useEffect(() => {
        const savedMode = localStorage.getItem('gsmart-mode')
        setMode(savedMode)

        const savedLang = localStorage.getItem('gsmart-lang')
        setLang(savedLang)
    }, [])

    const handleLanguageChange = (lan) => {
        i18n.changeLanguage(lan);
        setLang(lan)
        localStorage.setItem('gsmart-lang', lan)
    };

    const changeMode = () => {
        const newMode = (mode === 'bright') ? 'dark' : 'bright'
        setMode(newMode)
        localStorage.setItem('gsmart-mode', newMode)
    }

    return (
        <ModeProvider.Provider
            value={{ mode, changeMode, lang, handleLanguageChange }}
        >
            {children}
        </ModeProvider.Provider>
    );
}
